import { cleanObject } from '@shared/utils';
import getPieveRuntimeInstanceHeader from '@/lib/apps/getPieveRuntimeInstanceHeader.js';
import getPieveCompanyIdForRequest from '@/lib/auth/getPieveCompanyIdForRequest.js';
import { put } from '@/redux/requests/api.js';
import createRequestFailure from '@/redux/requests/lib/createRequestFailure.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';
import toValidationFailure from '@/redux/requests/lib/toValidationFailure.js';

const getFailureMessage = (failure = {}) => {
  const errorCode = String(failure?.error || '').trim();

  if (errorCode === 'usedInProduction') {
    return 'This connection is used in active workflows and cannot be deleted.';
  }

  if (errorCode) {
    return errorCode;
  }

  return 'Failed to delete connection';
};

const deleteCompanyCredential = ({ credentialId, appId, source = 'pieve-connections-page', signal } = {}, callback) => {
  const normalizedCredentialId = String(credentialId || '').trim();
  const normalizedAppId = String(appId || '').trim();
  const companyId = String(getPieveCompanyIdForRequest() || '').trim();

  if (!normalizedCredentialId) {
    return toValidationFailure('credentialId is required');
  }

  if (!normalizedAppId) {
    return toValidationFailure('appId is required');
  }

  if (!companyId) {
    return toValidationFailure('Active company is required to delete connection');
  }

  return put('/v1/sync/batch', {
    callback,
    data: {
      batch: [
        cleanObject(
          {
            type: 'credential',
            operation: 'delete',
            companyId,
            credentialId: normalizedCredentialId,
            appId: normalizedAppId,
            source: String(source || '').trim() || undefined
          },
          { strict: true }
        )
      ]
    },
    headers: {
      'x-mindcloud-instance': getPieveRuntimeInstanceHeader()
    },
    action: 'REMOVE_CONNECTION',
    meta: { credentialId: normalizedCredentialId },
    loader: 'deleteCompanyCredential',
    signal,
    onResponse: (responseShape) => {
      const responsePayload = responseShape?.data || {};
      const failedItems = Array.isArray(responsePayload?.failed) ? responsePayload.failed.filter((item) => item?.success === false) : [];

      if (failedItems.length > 0) {
        return {
          ...responseShape,
          data: createRequestFailure({
            message: getFailureMessage(failedItems[0]),
            status: responseShape?.status || null,
            data: responsePayload
          })
        };
      }

      const nextResponseShape = normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to delete connection'
      });

      if (nextResponseShape?.data?.success !== true) {
        return nextResponseShape;
      }

      return {
        ...nextResponseShape,
        data: {
          success: true,
          data: { success: true }
        }
      };
    }
  });
};

export default deleteCompanyCredential;
